module.exports = __webpack_public_path__ + "img/crossRedDigon.66b04221.png";